export default __webpack_public_path__ + "static/media/missionIcon.08d381f7.svg";